import { memo } from 'react';
import Link from 'next/link';
import cls from 'classnames';

import { Category } from '../../types';
import analytics from '../../services/analytics';

import useStyles from './styles';
import { CategoryProps } from './types';

function Categories({ className, onClick, selected, categories }: CategoryProps) {
  const styles = useStyles();

  const onItemClick = (category_name: string, page_name: string) => {
    analytics.gaEvent('category_select', {
      page_name,
      category_name,
    });
  };

  return (
    <section className={cls(styles.root, className)} onClick={onClick}>
      <div className={styles.heading}>Select a font style</div>
      <div className={styles.container}>
        {categories.map((current: Category) => {
          const { text, href, Icon, pageName } = current;

          return (
            <Link href={href} passHref={true} key={text}>
              <a
                onClick={() => onItemClick(text, pageName)}
                className={cls(styles.entry, selected === current && styles.entrySelected)}
                key={text}
              >
                {Icon && <Icon className={styles.icon} />} {text}
              </a>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default memo(Categories);
